<template>
    <span>
        <span class="d-inline-block" v-for="group in groups" :key="group.id" >
            <select @change="setCombination($event)" :data-id="group.id" class="form-control form-control-sm">
                <option v-for="attribute in group.values" :key="attribute.id" :value="attribute.id">{{ attribute.name }}</option>
            </select>
        </span>
    </span>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'variant-selector',
        props: ['product'],
        computed: {
            ...mapState({
                translations: state => state.translations,
            }),
            groups: function () {
                return this.product.attributes;
            },
        },
        methods: {
            setCombination: function (e) {
                const attribute = {
                    attributeId: e.target.value,
                    groupId: e.target.dataset.id,
                };
                this.$emit('changeAttributes', attribute);
            }
        }
    }
</script>

<style scoped lang="scss">
    select {
        display: inline-block;
        width: 80px;
        margin-right: 4px;
        background-image: url('/themes/realgeek/img/chevron-down.svg');
        background-position: calc(100% - 10px) 10px, calc(100% - 20px) 14px, 100% 0;
        background-size: 12px 12px, 12px 12px;
        background-repeat: no-repeat;
        -webkit-appearance: none;
        -moz-appearance: none;

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            -moz-appearance: initial;
            -webkit-appearance: initial;
            appearance: initial;
            background: transparent;
            padding: 0.375rem 0.75rem;
        }
    }
</style>
